import { Button, Grid, Typography, Divider } from '@mui/material'
import { useCallback, useState } from 'react'
import { metodoPrograma } from '../../../components/api'
import PrimeTable from '../../../components/PrimeTable'
import AutoComplete from '../../../components/AutoComplete/AutoComplete'

const EdicaoProduto = ({ dadosProduto }) => {
  const [refresh, setRefresh] = useState(0)

  const handleRemove = useCallback((dados) => {
    metodoPrograma('removeFluxoAtendimentoProduto', {
      idFluxoAtendimento: dados[0],
      idProduto: dados[1],
    }).then((res) => {
      if (res.status) {
        setRefresh((prev) => prev + 1)
      }
    })
  }, [])

  const salvaFluxoAtendimentoProduto = useCallback(
    (dados) => {
      metodoPrograma('salvaFluxoAtendimentoProduto', {
        idFluxoAtendimento: dados.acFLuxoAtendimento?.[0]?.[0],
        idProduto: dadosProduto?.[0],
      }).then((res) => {
        if (res.status) {
          setRefresh((prev) => prev + 1)
        }
      })
    },
    [dadosProduto],
  )

  return (
    <>
      <Grid item xs={12}>
        <Typography variant="h6" gutterBottom>
          Fluxo de Atendimento
        </Typography>
        <Divider />
      </Grid>

      <Grid item xs={12}>
        <PrimeTable
          codigo="CtrlProduto"
          action="listaFluxoAtendimentoProduto"
          rows={10}
          habSearch
          parametros={{ idProduto: dadosProduto?.[0] }}
          head={['Nome do Fluxo']}
          line={(item) => [item[2]]}
          onDelete={{ index: 1, action: handleRemove }}
          refresh={refresh}
          addButton={true}
          fastAddComponent={({ values, edit, close }) => (
            <Grid container spacing={2}>
              <Grid item xs={12} md={12}>
                <AutoComplete
                  metodo="buscaFluxoAtendimento"
                  codigo="CtrlProduto"
                  value={values?.acFLuxoAtendimento}
                  name="acFLuxoAtendimento"
                  label="Fluxo de Atendimento"
                  fullWidth
                  margin="dense"
                  variant="outlined"
                  size="small"
                  onChange={(_, val) => {
                    edit({
                      value: val,
                      field: 'acFLuxoAtendimento',
                    })
                  }}
                  textFieldProps={{
                    helperText: !values?.acFLuxoAtendimento
                      ? 'Campo Obrigatório!'
                      : '',
                    error: !values?.acFLuxoAtendimento,
                  }}
                />
              </Grid>
              <Grid
                item
                container
                xs={12}
                spacing={2}
                justifyContent="flex-end"
              >
                <Grid item xs={12} md={4}>
                  <Button
                    onClick={close}
                    fullWidth
                    variant="contained"
                    color="inherit"
                    style={{ margin: '5px' }}
                  >
                    Cancelar
                  </Button>
                </Grid>
                <Grid item xs={12} md={4}>
                  <Button
                    onClick={() =>
                      !!values?.acFLuxoAtendimento &&
                      salvaFluxoAtendimentoProduto(values) &&
                      close()
                    }
                    variant="contained"
                    fullWidth
                    color="primary"
                    style={{ margin: '5px' }}
                  >
                    Salvar
                  </Button>
                </Grid>
              </Grid>
            </Grid>
          )}
        />
      </Grid>
    </>
  )
}

export default EdicaoProduto
